import React from 'react';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';
import Image from 'components/common/Image';

import styles from './PromotionTile.module.scss';

interface PromotionTileProps {
  src?: string | null;
  className?: string | null;
  focusId: string;
  ttsText?: string | null;
  onClick?: () => void;
  onFocusSet?: () => void;
}

const PromotionTile = ({
  src,
  className = null,
  focusId,
  ttsText,
  onClick = () => {},
  onFocusSet = () => {},
}: PromotionTileProps) => (
  <Selectable
    onSelect={onClick}
    focusId={focusId}
    className={className}
    ttsText={ttsText}
    onFocusSet={onFocusSet}
    data-testid="promotion-tile"
    render={({ hasFocus }: { hasFocus: boolean }) => (
      <div
        className={classNames(
          'd-flex',
          'flex-column',
          styles.tile,
          hasFocus ? styles.focused : styles.unfocused,
        )}
      >
        <button
          type="button"
          onClick={onClick}
          // Safari hides the outline if the style is applied to the internal div
          className={classNames(
            'w-100 h-100',
            'position-relative',
            styles.button,
          )}
        >
          <Image
            alt="promotion tile background"
            src={src}
            className={classNames('w-100', 'h-100', styles.image)}
            data-testid="background-image"
          />
          <div className={classNames('w-100', 'h-100', styles.imageOverlay)} />
        </button>
      </div>
    )}
  />
);

export default React.memo(PromotionTile);
